import {TrackableEntity} from './data/ChangeTrackable';
import { IDictionary } from './data/TrackingModule';
import { DBMappingInfo } from '../framework.core/data/DBMappingInfo';

export class AeAcct{
    name: string = "";
    prepaid: number = 0;
    collect: number = 0;
}

export class AeAcctRecord extends TrackableEntity {
    id: number = 0;
    name0: string = '';
    prepaid0: number = 0;
    collect0: number = 0;
    name1: string = '';
    prepaid1: number = 0;
    collect1: number = 0;
    name2: string = '';
    prepaid2: number = 0;
    collect2: number = 0;
    name3: string = '';
    prepaid3: number = 0;
    collect3: number = 0;
    name4: string = '';
    prepaid4: number = 0;
    collect4: number = 0;
    [key:string]:any;       // To access by index
    constructor(init?:Partial<AeAcctRecord>) {
        super();
        this.key='id';
        Object.assign(this, init);
        this.noTrackProps.push('id');
        if(this.id === 0) this.id = this.GetNextId();
    }

    getDbMappings(arg?:any):IDictionary<DBMappingInfo> {
        return AeAcctRecord.dicFieldMappings;
    }

    static dicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_Id', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 1 }),
        'name0': new DBMappingInfo({ field: 'F_C1', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 1 }),
        'prepaid0': new DBMappingInfo({ field: 'F_F1', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 1 }),
        'collect0': new DBMappingInfo({ field: 'F_F2', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 1 }),
        'name1': new DBMappingInfo({ field: 'F_C2', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 1 }),
        'prepaid1': new DBMappingInfo({ field: 'F_F3', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 1 }),
        'collect1': new DBMappingInfo({ field: 'F_F4', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 1 }),
        'name2': new DBMappingInfo({ field: 'F_C3', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 1 }),
        'prepaid2': new DBMappingInfo({ field: 'F_F5', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 1 }),
        'collect2': new DBMappingInfo({ field: 'F_F6', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 1 }),
        'name3': new DBMappingInfo({ field: 'F_C4', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 1 }),
        'prepaid3': new DBMappingInfo({ field: 'F_F7', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 1 }),
        'collect3': new DBMappingInfo({ field: 'F_F8', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 1 }),
        'name4': new DBMappingInfo({ field: 'F_C5', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 1 }),
        'prepaid4': new DBMappingInfo({ field: 'F_F9', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 1 }),
        'collect4': new DBMappingInfo({ field: 'F_F10', table: 'T_AOTHERINFO', tbName: 'T_AOMMAIN', tbId: '@TBID', type: 1 }),
    };

    static hblDicFieldMappings:IDictionary<DBMappingInfo> = {
        'id': new DBMappingInfo({ field: 'F_Id', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TBID', type: 3 }),
        'name0': new DBMappingInfo({ field: 'F_C1', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TBID', type: 3 }),
        'prepaid0': new DBMappingInfo({ field: 'F_F1', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TBID', type: 3 }),
        'collect0': new DBMappingInfo({ field: 'F_F2', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TBID', type: 3 }),
        'name1': new DBMappingInfo({ field: 'F_C2', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TBID', type: 3 }),
        'prepaid1': new DBMappingInfo({ field: 'F_F3', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TBID', type: 3 }),
        'collect1': new DBMappingInfo({ field: 'F_F4', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TBID', type: 3 }),
        'name2': new DBMappingInfo({ field: 'F_C3', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TBID', type: 3 }),
        'prepaid2': new DBMappingInfo({ field: 'F_F5', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TBID', type: 3 }),
        'collect2': new DBMappingInfo({ field: 'F_F6', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TBID', type: 3 }),
        'name3': new DBMappingInfo({ field: 'F_C4', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TBID', type: 3 }),
        'prepaid3': new DBMappingInfo({ field: 'F_F7', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TBID', type: 3 }),
        'collect3': new DBMappingInfo({ field: 'F_F8', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TBID', type: 3 }),
        'name4': new DBMappingInfo({ field: 'F_C5', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TBID', type: 3 }),
        'prepaid4': new DBMappingInfo({ field: 'F_F9', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TBID', type: 3 }),
        'collect4': new DBMappingInfo({ field: 'F_F10', table: 'T_AOTHERINFO', tbName: 'T_AOHMAIN', tbId: '@TBID', type: 3 }),
    };
}
